import styled from "styled-components";

import { LoadingSkeletonSquareContainer } from "shared/components/molecules/LoadingSkeleton/atoms/LoadingSkeletonSquare/styles";

export const RankingLoadingSkeletonContainer = styled.div`
  .ranking {
    display: flex;
    gap: 1rem;
    justify-content: center;
    align-items: flex-end;
  }

  padding: 1rem;

  border: 1px solid ${({ theme }) => theme.feed.postBorderColor};
  border-radius: 4px;

  .user {
    display: flex;
    flex-direction: column;
    align-items: center;

    .texts {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }

  ${LoadingSkeletonSquareContainer} {
    margin-top: 16px;
  }
`;
